import { connect } from 'react-redux'
import Component from 'components/DashboardViewer/Filter/Dates'

export default connect()(Component)
